import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectFromConfig } from '@gandi/redux-config';
import { useTranslator } from '@gandi/translate';
import { Base, Button, Product } from '@gandi/ui';
import ItemPopover from './ItemPopover';
import { getItemType, getItemTitle, getItemSubtitle } from './helpers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "heading": "OrderItem-heading_1yVrG"
};
const productTypeIcons = {
  domains: 'domain',
  paas: 'simplehosting',
  iaas: 'hosting',
  certificates: 'security',
  mailbox: 'envelope',
  mailboxv2: 'envelope',
  'mailbox-standalone': 'envelope',
  sites: 'domain',
  premium_dns: 'helmet',
  phone_advisory: 'organizationWire',
  tmch: 'organizationWire'
};
const getIconName = (item, groupName) => {
  const iconName = item.product_type === 'domain_option' ? item.name : groupName;

  // $FlowFixMe[invalid-computed-prop]
  return iconName && productTypeIcons[iconName];
};
const CREATION_DELAY_GROUPS = ['oneClickCreation', 'webhosting'];
const selectShouldDisplayDNSTrialText = selectFromConfig('flags.SHOW_DNS_TRIAL_TEXT', true);
export default function OrderItem({
  orderItem,
  href
}) {
  const translator = useTranslator();
  const groupName = getItemType(orderItem);
  const shouldShowDNSTrialText = useSelector(selectShouldDisplayDNSTrialText);
  return /*#__PURE__*/_jsxs(Base, {
    backgroundColor: "white",
    children: [/*#__PURE__*/_jsxs(Base, {
      className: styles.heading,
      flex: true,
      flexColToRow: true,
      gap: "xsmall",
      flexJustifyBetween: true,
      marginBottom: "xsmall",
      overflow: "break",
      children: [/*#__PURE__*/_jsx(Product, {
        flexGrow1: true,
        flexExpandRight: true,
        icon: getIconName(orderItem, groupName),
        iconTheme: "green"
        // $FlowFixMe[incompatible-type] - to be discussed and refactored
        ,
        title: getItemTitle({
          item: orderItem,
          href
        }, translator)
        // $FlowFixMe[incompatible-type] - to be discussed and refactored
        ,
        subtitle: getItemSubtitle({
          item: orderItem
        }, translator, shouldShowDNSTrialText)
      }), /*#__PURE__*/_jsx(ItemPopover, {
        item: orderItem
      }), href && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          paddingY: "xsmall",
          small: true,
          iconAfter: "arrowRight",
          href: href,
          marginX: "small",
          children: translator.__("Let's get started")
        })
      })]
    }), CREATION_DELAY_GROUPS.includes(groupName) && /*#__PURE__*/_jsx(Base, {
      paddingX: "small",
      marginBottom: "small",
      children: translator.__('The automatic installation will begin once everything is ready, get started.')
    })]
  });
}